'use client';

import { Tooltip, type TooltipProps } from '@heroui/react';

/**
 * Tooltip styled to match the left-hand nav's dark tooltips (see
 * Sidebar.tsx's `!bg-[#18181B] !text-white`) — the shared look for all
 * tooltips on the DANI screen.
 */
export function DarkTooltip({ classNames, ...props }: TooltipProps) {
    return (
        <Tooltip
            {...props}
            classNames={{
                ...classNames,
                content: `!bg-[#18181B] !text-white ${classNames?.content ?? ''}`,
            }}
        />
    );
}
